import Flickity from "flickity";

class ImageCarousel {
  constructor(block) {
    this.block = block;
    this.itemsWrapper = block.querySelector(".image-carousel__items");
    this.isContainerLayout = this.itemsWrapper.classList.contains(
      "image-carousel__items--container"
    );
    this.flickityInit();
  }

  flickityInit() {
    this.flkty = new Flickity(this.itemsWrapper, {
      pageDots: false,
      autoPlay: true,
      wrapAround: true,
      prevNextButtons: false,
      adaptiveHeight: true,
      resize: true,
      contain: true,
      imagesLoaded: true,
      cellAlign: "left",
      groupCells: false,
    });
  }
}

export default ImageCarousel;
